export const UPDATE_REQUESTS_STATE = 'UPDATE_REQUESTS_STATE';